// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-welfare-lottery__receive-modal .plv-iar-welfare-lottery__modal__back-btn--black{position:absolute;top:14px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
